export const useCookieConsent = () => {
	const cookieConsent: Ref<boolean> = useCookie('cookieConsent', {
		maxAge: 365 * 24 * 60 * 60
	})
	return cookieConsent
}
